export enum FlashMessageGroup {
  LoginMessage = 'login-message',
  RecoverAccount = 'recover-account'
}
